/* eslint-disable @typescript-eslint/no-explicit-any */
import { Vue, Watch, Prop } from "vue-property-decorator";
import { SupplierInfoSubmitBO } from "@/service/supplier-meta/entity/SupplierInfoSubmitBO";
import { patchData } from "@/utils";
import {
  getFieldRules,
  getFieldCtrlFn,
  ElementUIFormItemRule,
  isFieldVisible,
  getFieldsCtrlFn,
  ElementUIFormRules,
  getFieldsRules,
} from "@/service/supplier-meta/common/supplier-field-ctrl";
// import { FormModel } from "@/service/common/entity/FormModel";
export abstract class StepForm extends Vue {
  /** 供应商来源（入口） */
  @Prop() sourceType!: number;
  /** 是否是服装品类 */
  @Prop() isClothingCategory!: boolean;
  /** 提交的数据 */
  @Prop() submitData!: SupplierInfoSubmitBO;
  /** 传入数据，用于初始化渲染 */
  @Prop({ required: false }) data?: SupplierInfoSubmitBO;
  /** 是否可缓存 */
  @Prop({ required: false, default: false }) cacheable?: boolean;
  abstract form: any;
  abstract validate(): Promise<boolean>;
  abstract getFormData(): any;
  created() {
    if (this.data && typeof this.data === "object") {
      this.setFormData(this.data);
    }
  }
  /** 是否已重新渲染 */
  rerendered = false;
  /**
   * 设置form数据，默认使用相同格式还原
   * @param data
   */
  setFormData(data: SupplierInfoSubmitBO) {
    patchData(data, this.form);
  }
  @Watch("form", {
    deep: true,
    immediate: true,
  })
  handleFormValueChange() {
    const partFormData = this.getFormData();
    this.$emit("formChange", partFormData);
  }

  getFieldRules(fieldName: string): ElementUIFormItemRule[] {
    const getRules = getFieldCtrlFn<ElementUIFormItemRule[]>(
      getFieldRules,
      this.sourceType,
      this.isClothingCategory,
      this.submitData
    );
    return getRules(fieldName);
  }
  /**
   * 是否显示某字段
   */
  get fieldVisible(): (field: string) => boolean {
    const visible = getFieldCtrlFn<boolean>(
      isFieldVisible,
      this.sourceType,
      this.isClothingCategory,
      this.submitData
    );
    return (field: string) => {
      return visible(field);
    };
  }
  /**
   * 获取字段校验配置
   * @param fieldNames
   * @returns
   */
  getFieldsRules(fieldNames: string[]): ElementUIFormRules {
    const getRules = getFieldsCtrlFn<ElementUIFormRules>(
      getFieldsRules,
      this.sourceType,
      this.isClothingCategory,
      this.submitData
    );
    return getRules(fieldNames);
  }
}
